module.exports = __webpack_public_path__ + "static/adnoc-b1ee3cb59dbff8c81340ddc44c3ec0af.jpg";